<template>
  <div class="general">
    <div class="banner">
      <img src="@/assets/images/general/banner.png" alt="" />
    </div>
    <div class="title">
      <img src="@/assets/images/general/title.png" alt="" />
    </div>
    <div class="title">数字经济教材</div>
    <div class="container">
      <div class="book_list">
        <div
          class="book_item"
          v-for="(item, index) in bookList"
          :key="index"
          @click="toDetail(item.url)"
        >
          <div class="white">
            <div class="shadow">
              <div class="whites">
                <div
                  class="title_pic"
                  :style="{
                    background: `url(${item.cover})`,
                    backgroundSize: `100% 100%`,
                  }"
                ></div>
              </div>
            </div>
          </div>

          <div class="text">
            {{ item.text }}
          </div>
          <div class="back"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import cover1 from "../../assets/images/general/cover.png";
// import cover2 from "../../assets/images/general/cover1.png";
// import cover3 from "../../assets/images/general/cover2.png";
// import cover4 from "../../assets/images/general/cover3.png";
// import cover5 from "../../assets/images/general/cover4.png";
// import cover6 from "../../assets/images/general/cover5.png";
// import cover7 from "../../assets/images/general/cover6.png";
// import cover8 from "../../assets/images/general/cover7.png";
// import cover9 from "../../assets/images/general/cover8.png";
import cover1 from "../../assets/images/general/back1.png";
import cover2 from "../../assets/images/general/back2.png";
import cover3 from "../../assets/images/general/back3.png";
import cover4 from "../../assets/images/general/back4.png";
import cover5 from "../../assets/images/general/back5.png";
import cover6 from "../../assets/images/general/back6.png";
import cover7 from "../../assets/images/general/back7.png";
import cover8 from "../../assets/images/general/back8.png";
import cover9 from "../../assets/images/general/back9.jpg";
export default {
  data() {
    return {
      bookList: [
        {
          cover: cover1,
          text: "人工智能给人类社会和生活带来巨大的改变，作为新时代的大学生都应具备人工智能视野，了解人工智能的应用，并能够运用人工智能技术分析和解决国际贸易的专业问题。",
          url: "https://web.ysy.crtvup.com.cn/#/bookstore/bookstoreDetail?goodsId=1877548323821457408",
        },
        {
          cover: cover2,
          text: "本书收集理了大量农业、制造业和服务业的实际应用案例，对云计算应用发展现状进行了详尽的分析，同时对云计算产业政策进行了务实的展望。",
          url: "https://web.ysy.crtvup.com.cn/#/bookstore/bookstoreDetail?goodsId=1877547976461783040",
        },
        {
          cover: cover3,
          text: "近年来，云计算产业快速发展，各个行业都积极投入对云计算技术的应用中，金融行业也不例外。本书可作为金融工程专业本科生的教学用书，亦可供对金融领域云计算应用感兴趣的读者阅读。",
          url: "https://web.ysy.crtvup.com.cn/#/bookstore/bookstoreDetail?goodsId=1877548433976463360",
        },
        {
          cover: cover4,
          text: "人工智能应深度赋能城市经济、生活、治理数字化转型，提升城市能级和核心竞争力。",
          url: "https://web.ysy.crtvup.com.cn/#/bookstore/bookstoreDetail?goodsId=1877540622135595008",
        },
        {
          cover: cover5,
          text: "传统金融模式中，大数据不仅可以根据其不同的数据类型为银行、保险业提供精准营销服务、完善股票的分析方法，还能有效增强金融风险的管控能力。",
          url: "https://web.ysy.crtvup.com.cn/#/bookstore/bookstoreDetail?goodsId=1877548153864065024",
        },
        {
          cover: cover6,
          text: "本书运用产业经济的主要相关原理，从理论角度进一步深入分析数字经济对国民经济的深刻影响，从宏观和产业视角系统化探索数字经济发展的规律。",
          url: "https://web.ysy.crtvup.com.cn/#/bookstore/bookstoreDetail?goodsId=1877548678533746688",
        },
        {
          cover: cover7,
          text: "本书系统研究湾区数字经济发展的空间结构理论、产业融合理论和协同创新理论，并结合理论分析国外著名湾区的数字经济发展状况，针对各个湾区的发展特点总结出发展湾区数字经济的思路，",
          url: "https://web.ysy.crtvup.com.cn/#/bookstore/bookstoreDetail?goodsId=1877548819537858560",
        },
        {
          cover: cover8,
          text: "本书侧重从经济学的基本理论方面对数字技术及数字经济做较为规范、详细的分析，从而提升学习者对数字经济基本规律、基本现象的理论分析能力，为学习其他数字经济方面的课程打好基础。",
          url: "https://web.ysy.crtvup.com.cn/#/bookstore/bookstoreDetail?goodsId=1877544323814395904",
        },
        {
          cover: cover9,
          text: "CorelDRAW 软件是一款“亲民”的设计软件，由于其运行速度快、操作简便、绘图功能强大，自问世以来就受到设计师们的青睐。",
          url: "https://web.ysy.crtvup.com.cn/#/bookstore/bookstoreDetail?goodsId=1877516845351833600",
        },
      ],
    };
  },
  created() {},
  methods: {
    toDetail(id) {
      window.open(id, "_blank");
    },
  },
};
</script>
<style lang='scss' scoped>
.general {
  background-color: #ffffff;
}
.banner {
  margin-bottom: 55px;
}
.title {
  text-align: center;
  margin-bottom: 12px;
  font-family: Microsoft YaHei UI, Microsoft YaHei UI;
  font-weight: 400;
  font-size: 24px;
  color: #2d2d2d;
  line-height: 28px;
  img {
    // width: 180px;
    height: 16px;
  }
}
.container {
  width: 1400px;
  margin: 52px auto 0;
  padding-bottom: 75px;
  .book_list {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    .book_item {
      cursor: pointer;
      width: 430px;
      height: 234px;
      border-radius: 4px 4px 4px 4px;
      margin-bottom: 65px;
      position: relative;
      background-color: #fcfcfc;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      .back {
        width: 84px;
        height: 88px;
        position: absolute;
        right: 0;
        bottom: 0;
        background: url("../../assets/images/general/item_back.png") no-repeat;
        background-size: 100% 100%;
        opacity: 0.2;
      }

      .text {
        font-family: Microsoft YaHei UI, Microsoft YaHei UI;
        font-weight: 400;
        font-size: 14px;
        color: #333333;
        line-height: 24px;
        margin-right: 24px;
        margin-top: -20px;
        width: 203px;
      }
      .white {
        width: 183px;
        height: 231px;
        transform-origin: left bottom;
        // background: url("../../assets/images/general/bg.png");
        background: #ffffff;
        box-shadow: 0 2px 5px rgba(136, 136, 136, 0.3);
        position: absolute;
        width: 183px;
        height: 231px;
        left: 0px;
        top: -10px;
        transition: transform 0.5s ease-in-out;
        transform: rotateZ(0deg);
        .shadow {
          position: absolute;
          top: 0;
          left: 0;
          width: 183px;
          height: 231px;
          transform-origin: left bottom;
          transition: transform 0.5s ease-in-out;
          background: rgb(180, 176, 176);
          .whites {
            width: 183px;
            height: 231px;
            transform-origin: left bottom;
            transition: transform 0.5s ease-in-out;
            background: #ffffff;
            .title_pic {
              // position: absolute;
              width: 183px;
              height: 231px;
              box-shadow: 0 2px 5px rgba(136, 136, 136, 0.3);
              transition: transform 0.5s ease-in-out;
            }
          }
        }
      }
    }
    .book_item:hover {
      box-shadow: 0 2px 5px rgba(136, 136, 136, 0.3);

      .white {
        transform-origin: left bottom;
        transform: rotateZ(-2deg) translateX(12px); 
        .shadow {
          transform-origin: left bottom;
          transform: rotateZ(0deg) translateX(-4px); 
          .whites {
            transform-origin: left bottom;
            transform: rotateZ(0deg) translateX(-4px); 
            .title_pic {
              transform-origin: left bottom;
              transform: rotateZ(-0deg) translateX(-4px); 
            }
          }
        }
      }
    }
  }
}
</style>